/**
 * Public entry of "Zakaj sam svoj računovodja", /v2/zakaj (no login, no router, no stores, no Tailwind: the page
 * brings its own .zsr- CSS). V2Controller::zakajAction serves the built zakaj.html.
 */
import { createApp } from "vue";
import ZakajView from "@/views/ZakajView.vue";

createApp(ZakajView).mount("#app");
